module.exports = __webpack_public_path__ + "static/media/Banner.12a74896.png";